import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
export default styled(List)(({ theme, ownerState }) => {
  const { palette } = theme;
  const { color } = ownerState;
  return {
    "& .MuiListItemButton-root": {
      color: palette["text"].main,
      "&:hover": { color: palette[color].main, background: palette['text'].light ,
    
    },
      "&:focus": {
        borderRightWidth: "3px",
        borderRightColor: palette[color].main,
        borderRightStyle: "solid",
        background: palette[color].main ,
      },

    },
    "& .MuiListItemIcon-root": {
      minWidth: 0,
      marginRight: 16,
    },
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  };
});
